<template>
    <b-modal id="inspection_delete" ref="inspection_delete" header-class="no-border" footer-class="no-border"
             @hidden="$emit('close')"
             :title="'Delete ' + this.inspection.data.attributes.code + '?'">
        You can't revert back your action if you delete this data. For further query, contact Database Manager!

        <template slot="modal-footer">
            <b-button size="sm" variant="secondary" @click="hideModal('inspection_delete')" v-text="'Cancel'"/>

            <state-button size="sm" variant="danger" :click="deleteInspection">Delete</state-button>
        </template>
    </b-modal>
</template>

<script>
import StateButton from "../../../../../components/Common/StateButton";

export default {
    name: "InspectionDeleteModal",

    components: {
        StateButton,
    },

    props: [
        'inspection'
    ],

    methods: {
        hideModal(refname) {
            this.$refs[refname].hide();
        },

        deleteInspection() {
            return new Promise((success, fail) => {
                this.$store.dispatch('deleteInspection', this.inspection)
                    .then(response => {
                        setTimeout(() => {
                            success();

                            this.$emit('deleted-inspection');

                            this.$notify('error filled', 'Success!', 'Deleted the inspection!', {
                                duration: 4000,
                                permanent: false
                            });

                            this.hideModal('inspection_delete');
                        }, 2000);
                    })
                    .catch(error => {
                        setTimeout(() => {
                            fail();
                        }, 1000);
                    });
            })
        },
    }
}
</script>

<style scoped>

</style>
